import { Box } from '@mui/joy'
import { useIsAppControl } from '@store/isApp'
import useChangeAnchorOutlink from '@components/ads/Article/Taboola/hooks/useChangeAnchorOutlink'
import color from '@ui/style/color.theme'
import pxToRem from '@utils/pxToRem'

const TaboolaAppFeedC = () => {
	const { ref } = useChangeAnchorOutlink()

	return (
		<Box
			id="taboola-recommendation-c_app_1x4"
			display={{ xs: 'block', md: 'none' }}
			ref={ref}
		/>
	)
}

const TaboolaMWFeedC = () => {
	return <Box id="taboola-recommendation-c_mobile_1x4" display={{ xs: 'block', md: 'none' }} />
}

const TaboolaFeedC = () => {
	const { isApp } = useIsAppControl()

	return (
		<Box
			className="print-hide"
			sx={{
				display: {
					xs: 'block',
					md: 'none',
				},
				border: `1px solid ${color.colGray3}`,
				padding: pxToRem(24),
			}}
		>
			{isApp ? <TaboolaAppFeedC /> : <TaboolaMWFeedC />}
		</Box>
	)
}

export default TaboolaFeedC
